<ion-header no-border>
  <app-close-button [isModal]="true" (click)="onCloseModal()"></app-close-button>
</ion-header>

<ion-content class="table-content">
  <div class="custom-inputs">
    <span class="page-title modal-title">{{'SHARED.Advanced_search' | translate}}</span>
    <input
      [(ngModel)]="searchWord"
      name="searchWord"
      class="search-input"
      type="search"
      placeholder="{{'SHARED.Enter_Keywords' | translate}}"
      (keydown.enter)="customSearch()"
    >
    <a class="ui-btn button-styled search-button" color="secondary" (click)="customSearch()">Search</a>
  </div>

  <app-tabs (currentTabChange)="onChangeTab($event)" [(currentTab)]="currentTab" [tabs]="tabs"></app-tabs>
  <div *ngFor="let tab of tabs" [hidden]="tab.key !== currentTab?.key" class="table-container display">
    <app-data-table
      *ngIf="tab.key === 'items'"
      [class.disabled]="!tableRecordsDisplay"
      [dataTableOptions]="dataTableOptions"
      class="data-table"
    ></app-data-table>

    <div class="folders-table" *ngIf="tab.key === 'folders' && filteredFoldersList.length">
      <app-folder-item
        *ngFor="let folderItem of filteredFoldersList"
        [folderItem]="folderItem"
        [mainUrl]="folderUrl"
        [searchWord]="searchWord"
        [disableClick]="!!panelConfig?.selectedIds?.length"
        (folderSelect)="onFolderSelect()"
        (click)="onFolderRowClick()"
      ></app-folder-item>
    </div>
    <div *ngIf="showEmptyMsg(tab.key)" class="empty-search-data">
      {{'SHARED.Empty_Search_Result' | translate}}
    </div>
  </div>
</ion-content>

<ion-footer *ngIf="panelConfig?.selectedIds?.length" class="folder-footer" no-border>
  <app-removal-panel
    [subTitle]="panelConfig.subTitle"
    [title]="panelConfig.title"
  >
    <ion-button
      *ngFor="let btn of panelConfig.buttons"
      class="page-button"
      color="secondary"
      (click)="onActionClicked(btn)"
    >
      {{btn.buttonText | translate}}
    </ion-button>
  </app-removal-panel>
</ion-footer>
